<script>
import { mapState } from 'vuex'

export default {
    name: 'BaseDashboard',
    data () {
        return {
            chartIntervalList: []
        }
    },
    computed: {
        ...mapState({
            currentProjectId: state => state.user.currentProjectId
        }),
        filterDateRange: {
            get () {
                return this.$store.state.dashboard.chartTimeRange
            },
            set (val) {
                this.$store.dispatch(this.$actionTypes.dashboard.CHART_TIME_RANGE, val)
            }
        },
        chartInterval: {
            get () {
                return this.$store.state.dashboard.chartInterval
            },
            set (val) {
                this.$store.dispatch(this.$actionTypes.dashboard.CHART_INTERVAL, val)
            }
        },
        currentProjectType () {
            return this.$store.getters.currentProjectType
        }
    },
    watch: {
        filterDateRange () {
            this.getDataDashboard()
        },
        currentProjectId () {
            this.getDataDashboard()
        }
    }
}
</script>
